import React, { FunctionComponent } from 'react';
import { PersonShowDetailsState } from './types';
import { SelectedStatus } from '../../../types/entries';

type Props = {
  state: PersonShowDetailsState;
  isPc: boolean;
  isOneYearPassed: boolean;
  selected_statuses: SelectedStatus[];
  handleMemoChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  handleSelectionStatusChanged: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  fetchValue: (selectionStatus: string, processingSelectionStatus: string) => string;
  handleCloseMemoModal: () => void;
};

export const Presentation: FunctionComponent<Props> = ({
  state,
  isPc,
  selected_statuses,
  handleMemoChange,
  handleSelectionStatusChanged,
  fetchValue,
  handleCloseMemoModal,
}) => {
  return (
    <>
      {/* SP: Memo modal - shown only on mobile */}
      <div
        className={`person__show__details__modal-bg ${state.isMemoModalOpen ? 'active' : ''}`}
        onClick={handleCloseMemoModal}
      />
      <div className={`person__show__details__modal ${state.isMemoModalOpen ? 'active' : ''}`}>
        <div className="person__show__details__modal__header">
          <button
            type="button"
            className="person__show__details__modal__header--close"
            onClick={handleCloseMemoModal}
          >
            <svg width="12" height="12" viewBox='0 0 12 12'>
              <path d="M0.735 12L0 11.265 5.265 6 0 0.735 0.735 0 6 5.265 11.265 0 12 0.735 6.735 6 12 11.265 11.265 12 6 6.735 0.735 12Z" fill="#19190F" />
            </svg>
          </button>
          <span className="person__show__details__modal__header--title">求職者メモ</span>
        </div>
        <div className="person__show__details__modal__body">
          <textarea
            className="person__show__details__memo"
            placeholder="求職者のメモを残せます"
            value={state.memo}
            onChange={handleMemoChange}
          />
        </div>
      </div>

      {/* PC: Full details section - shown on 1180px+ */}
      <div className="person__show__details">
        {/* Memo section */}
        <div className="person__show__details__section">
          <p className="person__show__details__section--title">求職者メモ</p>
          <textarea
            className="person__show__details__memo"
            placeholder="求職者のメモを残せます"
            value={state.memo}
            onChange={handleMemoChange}
          />
        </div>

        {/* Applies section */}
        {state.applies && state.applies.length > 0 && (
          <div className="person__show__details__section">
            <p className="person__show__details__section--title">エントリーした求人</p>
            <ul className="person__show__details__list">
              {state.applies.map((apply) => (
                <li className="person__show__details__list--item" key={apply.id}>
                  <div className="person__show__details__list--item--date">
                    エントリー日：{apply.created_at}
                  </div>
                  <div className="person__show__details__list--item--title">{apply.title}</div>
                  <select
                    className={`person__show__details__list--item--select ${
                      fetchValue(apply.selection_status, apply.processing_selection_status) === 'outstanding'
                        ? 'alert'
                        : ''
                    }`}
                    value={fetchValue(apply.selection_status, apply.processing_selection_status)}
                    onChange={handleSelectionStatusChanged}
                    disabled={apply.is_status_locked}
                    data-id={apply.id}
                  >
                    <option value="outstanding">未対応</option>
                    <option value="processing">対応中(未割り当て)</option>
                    {selected_statuses.map((status) => (
                      <option key={status.id} value={status.id}>
                        {status.name}
                      </option>
                    ))}
                    <option value="adopted">採用済み</option>
                    <option value="not_adopted">不採用</option>
                  </select>
                  {apply.is_status_locked && (
                    <span className="tooltip">
                      応募から1年以上経過しているため、選考ステータスは変更できません
                    </span>
                  )}
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* Events section */}
        {state.events && state.events.length > 0 && (
          <div className="person__show__details__section">
            <p className="person__show__details__section--title">エントリーしたイベント</p>
            <ul className="person__show__details__list">
              {state.events.map((event) => (
                <li className="person__show__details__list--item" key={event.id}>
                  <div className="person__show__details__list--item--sub">
                    <span className="person__show__details__list--item--date">
                      エントリー日：{event.created_at}
                    </span>
                    {event.cancel && (
                      <span className="person__show__details__list--item--cancel">{event.cancel}</span>
                    )}
                  </div>
                  <div className="person__show__details__list--item--title">{event.title}</div>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </>
  );
};
